import url from 'libraries/front-end-core/core/url'
import { Controller } from 'libraries/front-end-core/core/Router'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import { DASHBOARD } from 'constants/controllers'
import { ALL_AOLS } from 'constants/aol/aol'
import NotFound from 'components/NotFound'

export default new Controller({
  name: 'LegacyHomepageRedirect',
  route: ':aol',
  controller (Router, evt, render) {
    const { params } = evt

    // This route pattern matches ANY single path segment, so it has to filter
    // to known AOLs itself (route-parser has no param-level enum constraint) -
    // otherwise a typo'd/unknown single-segment URL (e.g. /fooo) would get
    // treated as a legacy AOL bookmark and redirected to the dashboard instead
    // of showing a real 404.
    if (!ALL_AOLS.includes(params.aol)) {
      render({ Main: NotFound }, {}, {})
      return evt.url
    }

    const target = url(DASHBOARD, params)
    replaceUrl(target)
  }
})
